import React, { Component } from 'react';

import notice1 from "../../assets/images/idCard/notice1@2x.png"
import notice2 from "../../assets/images/idCard/notice2@2x.png"
import notice3 from "../../assets/images/idCard/notice3@2x.png"
import apply   from "../../assets/images/idCard/apply.gif"
import "../notice/Notice.scss"
import PropTypes from 'prop-types';

class Notice extends Component {
    render () {
        return (
            <div className="notice">
                <div className="noticeShow">
                    <div className="title">证件拍摄须知</div>
                    <ul className="con">
                        <li>
                            <img src={notice1} alt="" />
                            <div className="row">
                                <div className="row1">边角完整</div>
                                <div className="row2">确认证件完全处于图片内</div>
                            </div>
                        </li>
                        <li>
                            <img src={notice2} alt="" />
                            <div className="row">
                                <div className="row1">字体清晰</div>
                                <div className="row2">保证精准对焦，使证件上文字和照片清晰可见</div>
                            </div>
                        </li>
                        <li>
                            <img src={notice3} alt="" />
                            <div className="row">
                                <div className="row1">亮度均匀</div>
                                <div className="row2">避免图片出现遮挡光线、反光等情况</div>
                            </div>
                        </li>
                    </ul>
                    <img src={apply} width="100%" alt="" />
                    <div className="confirm">
                        <div className="btn" onClick={this.props.closeNotice}>确定</div>
                    </div>
                </div>
            </div>
        )
    }
}

Notice.propTypes = {
    closeNotice:PropTypes.func,
}

export default Notice;
